import React, { useState, useEffect, useRef } from "react";



function Pagination(props) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentPageNo, setcurrentPageNo] = useState(props.currentPage);
  const wrapperRef = useRef(null);

  useEffect(
    () => {
      setcurrentPageNo(props.currentPage);
    },
    [props]
  );
  const onNextPage = pageNumber => {
    if (pageNumber === props.numberOfPages) {
      console.log("nothing");
    } else {
      props.updatePageNumberCallback(pageNumber + 1);
    }
  };

  const onPreviousPage = pageNumber => {
    console.log("onPreviousPage clicked");
    if (pageNumber - 1 >= 1) {
      props.updatePageNumberCallback(pageNumber - 1);
    }
  };

  return (
    <div className="pagination-wrapper">
      {currentPageNo > 1 && (
        <div
          className="item prev"
          onClick={() => onPreviousPage(currentPageNo)}
        >
          <div className="arrow left-arrow">
            {props.homeImages &&
              props.homeImages.leftArrow &&
              props.homeImages.leftArrow.thumbnail && (
              <img src={props.homeImages.leftArrow.thumbnail} />
            )}
          </div>
        </div>
      )}
      {props.numberOfPages ? (
        <div className="item page-no">
          <span>{`PAGE ${  currentPageNo  } OF ${  props.numberOfPages}`}</span>
        </div>
      ) : (
        <div>no blogs with selected filter</div>
      )}
      {currentPageNo < props.numberOfPages && (
        <div className="item next" onClick={() => onNextPage(currentPageNo)}>
          {props.homeImages &&
            props.homeImages.rightArrow &&
            props.homeImages.rightArrow.thumbnail && (
            <div className="arrow right-arrow">
              <img src={props.homeImages.rightArrow.thumbnail} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Pagination;
